import { Coins, CreditCard, Disc3, Star } from "lucide-react";

import { ROTA_FIDELIZE_CARTAO, ROTA_FIDELIZE_CASHBACK, ROTA_FIDELIZE_PONTUACAO, ROTA_FIDELIZE_ROLETA } from "./rotas";

// As formas de fidelizar o cliente. Cada uma tem a sua página (v1.5.722).
export const FERRAMENTAS = [
  {
    id: "cashback",
    titulo: "Cashback",
    icone: Coins,
    cor: "from-emerald-500 to-teal-600",
    corSuave: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
    rota: ROTA_FIDELIZE_CASHBACK,
    disponivel: true,
    resumo: "O cliente ganha uma porcentagem de volta a cada pedido e volta pra gastar.",
    itens: ["Você escolhe a porcentagem e onde vale", "O saldo aparece pro cliente no cardápio", "Relatório de quanto voltou em vendas"],
  },
  {
    id: "pontuacao",
    titulo: "Pontuação",
    icone: Star,
    cor: "from-amber-500 to-orange-600",
    corSuave: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
    rota: ROTA_FIDELIZE_PONTUACAO,
    disponivel: false,
    resumo: "Cada pedido acumula pontos que o cliente troca por produtos ou descontos.",
    itens: ["Regra de pontos por real gasto", "Catálogo de recompensas", "Saldo visível no cardápio do cliente"],
  },
  {
    id: "cartao",
    titulo: "Cartão Fidelidade",
    icone: CreditCard,
    cor: "from-sky-500 to-blue-600",
    corSuave: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
    rota: ROTA_FIDELIZE_CARTAO,
    disponivel: true,
    resumo: "10 carimbos, 2 de presente: na 8ª compra o sistema entrega o prêmio sozinho.",
    itens: ["Carimbo automático a cada compra", "Prêmio sorteado e entregue sem código", "Cartão animado no cardápio e foto no WhatsApp"],
  },
  {
    id: "roleta",
    titulo: "Roleta",
    icone: Disc3,
    cor: "from-fuchsia-500 to-purple-600",
    corSuave: "bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-400",
    rota: ROTA_FIDELIZE_ROLETA,
    disponivel: false,
    resumo: "O cliente gira a roleta no cardápio e pode ganhar um mimo — diversão que vira pedido.",
    itens: ["Prêmios e probabilidades configuráveis", "Limite por cliente", "Válida por tempo limitado"],
  },
];

export const ferramenta = (id) => FERRAMENTAS.find((f) => f.id === id);
